<template>
  <article class="weekly-print-detail">
    <h2 style="text-align: center; margin-bottom: 20px">每周食品安全排查记录</h2>
    <a-descriptions bordered :column="2">
      <a-descriptions-item label="检查日期">
        {{ formatDate(form?.others?.check_date) }}
      </a-descriptions-item>
      <a-descriptions-item label="记录编号">
        {{ form?.others?.record_code || '-' }}
      </a-descriptions-item>
      <a-descriptions-item label="管控日期范围" :span="2">
        {{ formatDateRange(form?.others?.control_date) }}
      </a-descriptions-item>
      <a-descriptions-item label="上周回顾" :span="2">
        <div style="white-space: pre-wrap">{{ form?.others?.review || '-' }}</div>
      </a-descriptions-item>
      <a-descriptions-item label="本周排查" :span="2">
        <div style="white-space: pre-wrap">{{ form?.others?.troubleshooting || '-' }}</div>
      </a-descriptions-item>
      <a-descriptions-item label="整改措施" :span="2">
        <div style="white-space: pre-wrap">{{ form?.others?.measures || '-' }}</div>
      </a-descriptions-item>
      <a-descriptions-item label="参加人员" :span="2">
        {{ formatParticipants(form?.others?.participants) }}
      </a-descriptions-item>
      <a-descriptions-item label="备注" :span="2">
        <div style="white-space: pre-wrap">{{ form?.others?.remark || '-' }}</div>
      </a-descriptions-item>
    </a-descriptions>
  </article>
</template>

<script>
import moment from 'moment';

export default {
  name: "PrintDetail",
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '-';
      return moment(date).format('YYYY-MM-DD');
    },
    formatDateRange(dateRange) {
      if (!dateRange || !Array.isArray(dateRange) || dateRange.length !== 2) {
        return '-';
      }
      const start = moment(dateRange[0]).format('YYYY-MM-DD');
      const end = moment(dateRange[1]).format('YYYY-MM-DD');
      return `${start} 至 ${end}`;
    },
    formatParticipants(participants) {
      if (!participants || participants.length === 0) return '-';
      if (Array.isArray(participants)) {
        return participants.join('、');
      }
      return participants;
    }
  }
};
</script>

<style lang="less" scoped>
.weekly-print-detail {
  padding: 20px;
  
  :deep(.ant-descriptions-item-label) {
    font-weight: bold;
    background-color: #fafafa;
  }
  
  :deep(.ant-descriptions-item-content) {
    min-height: 32px;
  }
}
</style>
